import { TonConnectButton } from '@tonconnect/ui-react';
import './header.scss';

export const Header = () => {
    return (
        <header>
            <span>My App with React UI</span>
            <TonConnectButton />
        </header>
    );
};
